<template>
  <div class="homeIntro__container">
    <div v-if="Nprj === 0" class="intro__container">
      <h2 class="intro">
        Art Direction<br />
        Digital Branding <br />
        Web Development<br />
        Creative Coding<br />
      </h2>
    </div>
    <div v-else class="intro__container">
      <h2 class="intro">
        {{ dbPrj[Nprj-1].data.title[0].text }}
      </h2>
      <h2 class="intro intro__text">
        {{ dbPrj[Nprj-1].data.text_intro }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  computed:{
    Nprj(){
      return this.$store.state.homePrj;
    },
    dbPrj(){
      return this.$store.state.Prj;
    }
  }
};
</script>

<style lang="scss" scoped>
.homeIntro__container {
  position: fixed;
  z-index: 999;
  background: black;
  height: inherit;
  width: 33vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-left: 55px;
  padding-bottom: 16px;
   @media screen and (max-width:767px) {
     margin-top: 20px;
     padding-left: 0;
     width: 100%;
     background: none;
     height: 20vh;
     position: static;
     justify-content: flex-start;
   }
}

.intro {
  font-family: Lausanne;
  color: white;
  font-weight: bold;
  //   font-size: 40px;
  font-size: 2.8vw;
  line-height: 120%;
  margin-right: 2vw;
  &__text{
    margin-top: 4vw;
  }
  @media screen and (max-width:767px) {
    font-size: 3vh;
  }
}

.intro__link {
  margin-top: 48px;
  a {
    color: white;
    text-decoration: none;
    font-family: Lausanne;
    font-size: 16px;
    margin-right: 10px;
    font-weight: bold;

    &:hover {
      text-decoration: underline;
    }
  }
  display: flex;
  align-items: center;
}
</style>